var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCbSpaceFormIcon = function SvgCbSpaceFormIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4D5B5A",
    fillRule: "evenodd",
    d: "M9.491 1.126c.309-.168.682-.168.99 0l7.356 4L10 9.39 2.15 5.118zm-.125 9.335V19l-7.347-3.997a1.04 1.04 0 0 1-.54-.91V6.168zM10.634 19v-8.54l7.888-4.291v7.923c0 .38-.208.73-.541.91z",
    clipRule: "evenodd"
  })));
};
export { SvgCbSpaceFormIcon as ReactComponent };